import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EAlarmManagementFields = {
	isActive: 'isActive',
	frequency: 'frequency',
	numberOfRepetitions: 'numberOfRepetitions',
	repetitionHours: 'repetitionHours',
	repetitionMinutes: 'repetitionMinutes',
	renotify: 'renotify',
	renotifyHours: 'renotifyHours',
	renotifyMinutes: 'renotifyMinutes',
	isEmail: 'isEmail',
	isNotification: 'isNotification',
	recipient: 'recipient',
	roles: 'roles',
	users: 'users',
	networkElementFields: 'networkElementFields',
	autoClearMinutes: 'autoClearMinutes',
} as const;

export type TAlarmManagementFields = TValueOfStringRecord<typeof EAlarmManagementFields>
